import React from 'react'

export default function LandingSolve() {
  const solveItems = [
    {
      number: '01',
      title: "“I don't have the hours to manage this.”",
      text: "A senior schedule isn't built for site visits or material approvals. We remove the coordination entirely, surfacing only the decisions that need your signature.",
    },
    {
      number: '02',
      title: '“What if I end up managing a disaster?”',
      text: 'One team owns the outcome from first sketch to handover — not a dozen disconnected vendors reporting to no one.',
    },
    {
      number: '03',
      title: "“I've been disappointed by contractors before.”",
      text: "Our own site team supervises every trade daily. There's no vendor to blame, because there's only one team — ours.",
    },
  ]

  return (
    <>
      <section className="landsolve-section">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="landsolve-head">
                        <h4 className="heading center-heading">What This Solves</h4>
                        <p>The concerns we hear most, before a project begins during early discussions.</p>
                    </div>

                    <div className="landsolve-grid">
                        {solveItems.map((item) => (
                        <div className="landsolve-card" key={item.number}>
                            <span>{item.number}</span>
                            <h5 className='landsolve-title'>{item.title}</h5>
                            <p>{item.text}</p>
                        </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
      </section>
    </>
  )
}
